package modysy

import modysy.model.GameObject

package object simulation {

  /** Change poses of objects according to their velocities and the amount of simulated time.
    *
    * @param objects   The sequence of objects to be moved.
    * @param timeDelta The amount of simulated time.
    */
  def moveObjects(objects: Seq[GameObject], timeDelta: Double): Unit = {
    objects foreach { o =>
      o.body.pose.translation += o.body.velocity.linear * timeDelta
      o.body.pose.orientation += o.body.velocity.angular * timeDelta
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/package.scala